import { Button, Chip, Grid, Paper, Stack, Typography } from "@mui/material"
import { useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { useAppSelector } from "../../../../../../hooks/store-hooks"
// Icon
import DeleteIcon from '@mui/icons-material/Delete'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'

export const RecorteIdadeFilterPreview = () => {
    // State
    const { createRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)
    // Hook
    const { removeCreateRecorteFormFiltros } = useRecortesExtracaoService()

    return (
        <>
            <Grid item container xs={6} spacing={2} mb={2}>
                <Paper elevation={3} sx={{ padding: 2, width: '100%' }}>
                    <Grid item xs={12} container justifyContent={'space-between'} alignItems="center" my={1}>
                        <Grid item>
                            <Typography
                                variant="body1"
                                color="primary"
                                fontWeight="bold"
                                textTransform="uppercase"
                                mr={2}
                            >
                                Idade
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="outlined"
                                startIcon={<DeleteIcon />}
                                onClick={() => removeCreateRecorteFormFiltros({ filtro: 'idade' })}
                            >
                                Remover filtro
                            </Button>
                        </Grid>
                    </Grid>

                    {createRecorteExtracaoForm.fields.Filtros &&
                        createRecorteExtracaoForm.fields.Filtros.idade && (
                            <Grid item xs={12}>
                                <Stack
                                    direction="row"
                                    flexWrap="wrap"
                                >
                                    {createRecorteExtracaoForm.fields.Filtros.idade.min &&
                                        <Chip
                                            key={0}
                                            icon={<CalendarMonthIcon />}
                                            label={`de: ${createRecorteExtracaoForm.fields.Filtros.idade.min} anos`}
                                            sx={{
                                                m: 0.5
                                            }}
                                        />
                                    }
                                    {createRecorteExtracaoForm.fields.Filtros.idade.max &&
                                        <Chip
                                            key={1}
                                            icon={<CalendarMonthIcon />}
                                            label={`até: ${createRecorteExtracaoForm.fields.Filtros.idade.max} anos`}
                                            sx={{
                                                m: 0.5
                                            }}
                                        />
                                    }
                                </Stack>
                            </Grid>
                        )}
                </Paper>
            </Grid>
        </>
    )
}